<template>
  <div class="product_module">

    <div class="product-title">
      <div class="mainTitle">产品展示</div>
    </div>
    <div class="subTitle subSpace">
      <span class="mSubStl">Product</span>
      <span class="mianColo">&nbsp;Display</span>
    </div>
    <div class="product_imgs">
      <el-row>
        <el-col :span="8" v-for="(product,index) in productArr" :key="index">
          <div class="list_imgs" @click="viewProduct(product.pid)">
            <img :src="product.path" alt="" width="100%" height="280">
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pro_space">
      <el-button class="more_btn h_pro_more" @click="productModule">
        查看更多&nbsp;&nbsp;<i class="el-icon-right more_icon"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import { productList } from '@/api/frontApi/product';
export default {
  data() {
    return {
      productArr: [
        { path: '../../../../static/img/product/vehicle-1.png', index: 1 },
        { path: '../../../../static/img/product/vehicle-2.png', index: 2 },
        { path: '../../../../static/img/product/vehicle-3.png', index: 3 },
        { path: '../../../../static/img/product/vehicle-4.png', index: 4 },
        { path: '../../../../static/img/product/vehicle-5.png', index: 5 },
        { path: '../../../../static/img/product/vehicle-6.png', index: 6 },
        { path: '../../../../static/img/product/vehicle-7.png', index: 7 },
        { path: '../../../../static/img/product/vehicle-8.png', index: 8 }
      ]
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    getProductList() {
      productList(0).then(res => {
        if (res.data.length > 0) {
          this.productArr = [];
          let showArr = res.data.slice(0, 8);
          showArr.forEach(item => {
            if (item.picMain) {
              let tempObj = { path: '', pid: 0, name: '' };
              tempObj.name = item.proTitle;
              tempObj.path = item.picMain;
              tempObj.pid = item.proId;
              this.productArr.push(tempObj);
            }
          });
        }
      });
    },
    productModule(item) {
      this.$router.push({ name: 'product' });
    },
    viewProduct(productId) {
      this.$router.push({
        name: 'product',
        params: {
          productId: productId,
          proType: 0
        }
      });
    }
  }
};
</script>
<style scoped>
.product_module {
  width: 100%;
  text-align: center;
  padding-top: 15px;
  background-color: #e9f5f7;
  padding-bottom: 20px;
}

.product-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
}
.load-solo {
  background: transparent;
  border: 0;
  border-radius: 0;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 20px;
  padding: 15px 50px;
  position: relative;
  cursor: pointer;
}

.load-solo:before {
  transition: all 0.8s cubic-bezier(0.7, -0.5, 0.2, 2);
  content: '';
  width: 1%;
  height: 100%;
  background: #e9f5f7;
  position: absolute;
  top: 0;
  left: 0;
}

.load-solo span {
  /* mix-blend-mode: normal; */
  /* color: #e9f5f7; */
}

.load-solo:hover:before {
  background: #00697f;
  width: 100%;
  border-radius: 4px;
  /* color: #e9f5f7; */
  color: red;
}

.product_imgs {
  width: 70%;
  margin: 0 auto;
}

.list_imgs {
  overflow: hidden;
  width: 100%;
  height: 280px;
}
.list_imgs img {
  transition: all 2s;
  width: 100%;
  height: 100%;
}
.list_imgs img:hover {
  cursor: pointer;
  transform: scale(1.2);
}
.h_pro_more {
  background-color: #e9f5f7;
}
.h_pro_more:hover {
  background-color: #00697f;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeProduct.vue